import { Button, styled } from '@mui/material';

import { primaryColors } from '~components/theme/styles/colors';

export const AccountPanelOption = styled(Button)({
  minWidth: 0,
  padding: '8px',
  borderRadius: '4px',
  '&:hover': {
    backgroundColor: primaryColors[900],
  },
  width: '100%',
  transition:
    'border-width 0s linear, border-color 0.1s ease-in-out, margin 0s linear, background-color 0.1s ease-in-out',
});
